import { QuestionsV3, QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class NestedGroupQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.NESTED_GROUP;
  nestedQuestions: QuestionsV3[];

  constructor(options: any = {}) {
    super(options);
    this.nestedQuestions = options['nestedQuestions'] || [];
  }
}
